import _ from "lodash";
import { useSelector } from "react-redux";
import GenericPopover from "shared/popovers/GenericPopover";
import { GenericButton } from "shared/ui-basics/buttons";
import Tag from "shared/ui-basics/ui-components/tag";
import styled from "styled-components";
import { getCxAttributesItemsIds } from "utils/helpers";
import { InformationType, StatusCode } from "utils/optionsSets/OptionSets";


const TagsCxAttribute = ({ data, allRecordsSelector }) => {
    const allActiveItems = useSelector((state) => _.get(state, allRecordsSelector)?.filter((item) => item?.statusCode === StatusCode.Active) || []);
	const currentItem = allActiveItems?.find((opp) => opp.id === data?.id);
    const tagIds = getCxAttributesItemsIds({ data: currentItem, informationType: InformationType.Tags, attributeItem: "tags" });
	const currentTagsIds = useSelector((state) => state?.libraries?.tags?.filter(tag => tagIds?.includes(tag.id))?.map(tag => tag?.id));

	const custom = (
		<div>
			{currentTagsIds?.slice(2, Infinity).map((tag) => (
				<div key={tag} className="mb-1">
					<Tag tagId={tag}/>
				</div>
			))}
		</div>
	);
	return (
		<WrapperDiv className="d-flex">
			{currentTagsIds?.slice(0, 2).map((tag) => (
				<div key={tag} className="mb-1 ms-1">
					<Tag tagId={tag}/>
				</div>
			))}
			{currentTagsIds?.length > 2 && (
				<div className="ms-1">
					<GenericPopover custom={custom}>
						<GenericButton variant="light" iconClassName="ms-2" size="xs" className="p-1">
							+{currentTagsIds?.length - 2}
						</GenericButton>
					</GenericPopover>
				</div>
			)}
		</WrapperDiv>
	);
};

const WrapperDiv = styled.div`
	display: -webkit-box;
	overflow: hidden;
`;

export default TagsCxAttribute;
